/* =============================================================
   Dots for Spots — v8 Chrome theme.js
   Minimal JS: mobile menu, cart drawer open/close, nav pulse
   All section-level JS lives inline in each section file.
   ============================================================= */

(function () {
  'use strict';

  /* --- Mobile nav toggle ------------------------------------ */
  const hamburger = document.getElementById('v8-hamburger');
  const mobileMenu = document.getElementById('v8-mobile-menu');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  /* --- Close mobile menu on ESC ---------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('open')) {
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    }
  });

  /* --- Sticky header shrink on scroll ---------------------- */
  const header = document.querySelector('header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* --- Announcement bar pulse animation -------------------- */
  const pulseDots = document.querySelectorAll('.v8-pulse-dot');
  pulseDots.forEach(function (dot) {
    // CSS handles the pulse; this just ensures the class is present
    dot.classList.add('v8-pulse');
  });

  /* --- Product form: prevent double submit ----------------- */
  document.querySelectorAll('[id^="ProductForm-"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        setTimeout(function () { btn.disabled = false; }, 3000);
      }
    });
  });

  /* --- Cart quantity links — AJAX update ------------------- */
  // Cart page uses href-based qty change links (Shopify default).
  // No AJAX needed for cart.json approach; redirect is acceptable
  // for a non-drawer cart. Uncomment to enable AJAX cart updates.
  //
  // document.querySelectorAll('[data-qty-update]').forEach(function (link) {
  //   link.addEventListener('click', function (e) {
  //     e.preventDefault();
  //     const url = link.getAttribute('href');
  //     fetch(url).then(function () { window.location.reload(); });
  //   });
  // });

})();
